export default __webpack_public_path__ + "static/media/antenna.972da3fa.svg";